<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Check Out</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>

  <div class="main-content check-out__main-content">
    <div class="col-md-12">
      <p><i class="fas fa-user"></i> Lead Worker</p>
      <p *ngIf="leadWorker">{{leadWorker.name}}</p>
      <div class="check-out__main-content-dflex">
        <button class="btn btn-primary btn-link check-out__btn" type="button"
          (click)="checkOut('CLOSED', false)">Check Out - Close</button>
        <button class="btn btn-primary btn-link check-out__btn" type="button"
          (click)="checkOut('SUSPENDED', false)">Check Out - Suspend</button>
        <button class="btn btn-primary btn-link check-out__btn" type="button"
          (click)="checkOut('SURRENDERED', false)">Check Out - Surrender</button>
      </div>
    </div>

    <div class="col-md-12" *ngIf="additionalWorkers.length > 0">
      <p><i class="fas fa-users"></i> Additional Workers</p>
      <ul>
        <li *ngFor="let worker of additionalWorkers" class="check-out__add-worker"> {{worker.name}}
          <div>
            <button class="btn btn-primary rounded btn-sm check-out__add-worker-btn"
              type="button" (click)="checkOut('SUSPENDED', true, worker.siteSessionId, worker.workerUserId)">check
              out</button>
          </div>
        </li>
      </ul>
    </div>

  </div>

  <p-footer>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
